import { writable } from "svelte/store";

export type ToastVariant = "info" | "success" | "warning" | "error";
type ToastData = {
  id?: number;
  variant: ToastVariant;
  message: string;
  duration?: number;
};

type Toast = ToastData & { id: number };

export type ToastStore = ReturnType<typeof createToastStore>;

export function createToastStore() {
  const { update, subscribe } = writable<Toast[]>([]);

  return {
    subscribe,
    add(toast: ToastData) {
      update((toasts) => [
        ...toasts,
        {
          id: toast.id ?? Math.floor(Math.random() * 1000000),
          ...toast,
        },
      ]);
    },
    addSuccess(message: string) {
      this.add({ message, variant: "success" });
    },
    addError(message: string) {
      this.add({ message, variant: "error" });
    },
    remove(toastId: number) {
      update((toasts) => toasts.filter((toast) => toast.id !== toastId));
    },
    removeAll() {
      update(() => []);
    },
  };
}
